angular.module('businessThread')
    .component('businessThreadTodoTable', {
        bindings: {
            ids: '<',
            query: '<',
            onDataLoaded: '&'
        },
        templateUrl: 'app/business-thread/todo-table.html',
        controller: function ($scope, Todo, TodoService) {
            this.TodoService = TodoService
            this.filters = {}

            this.$onChanges = () => this.load()

            this.load = () => {
                if (angular.isArray(this.ids) && !this.ids.length) {
                    this.page = emptyPage()
                    this.notifyLoaded()
                    return
                }

                let params = angular.extend({}, this.filters, {
                    ids: this.ids,
                    search: this.query
                })
                return Todo.table(params).$promise.then(data => {
                    this.page = data
                    this.notifyLoaded()
                })
            }

            this.notifyLoaded = () => {
                if (angular.isFunction(this.onDataLoaded)) {
                    this.onDataLoaded({$page: this.page})
                }
            }
            this.isDelayed = item => item && item.dateOfIssue && moment().startOf('day').isAfter(item.dateOfIssue)
                && (item.status == null || ['DONE_NEGATIVE', 'DONE_POSITIVE'].indexOf(item.status) === -1)

            $scope.$on('todo.updated', () => this.load())
            $scope.$on('todo.deleted', () => this.load())

            const emptyPage = () => ({list: [], fullListSize: 0, objectsPerPage: 50, pageNumber: 1})
        }
    })
